import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

import AdviceSection from '../common/AdviceSection';
import EUCountryCard from '../common/cards/EUCountryCard';
import IndividualCountrySelect from '../common/select-filters/IndividualCountrySelect';
import SelectDataset from '../common/SelectDataset';
import CountryCards from '../common/cards/CountryCards';
import Pagination from '../common/pagination/Pagination';
import Methodology from '../common/Methodology';

import { getSocialDialogueCountries, getSocialDialogueData } from '../../api';

const DevelopmentEUCountries = props => {

	const pageSize = 15;

	const [euData, setEUData] = useState(null);
	const [countriesData, setCountriesData] = useState([]);
	const [countryList, setCountryList] = useState([]);
	const [pageOfItems, setPageOfItems] = useState([]);
	const [filters, setFilters] = useState({
		countries: [],
		dataset: ''
	});

	useEffect(() => {
		// Update the title of the page
		document.title = props.literals.L20810 +  " - " + props.literals.L22020 + " - " + props.literals.L363;

		getSocialDialogueCountries()
		.then((res) => {
			setCountryList(res.resultset);
		});

		fetchData();
	}, [])

	useEffect(() => {
		fetchData();
	}, [filters])

	const fetchData = () => {
		getSocialDialogueData( filters )
		.then((res) => {
			res.resultset.filter(country => country.countryCode === 'EU27_2020').map(filteredCountry => {
				setEUData( filteredCountry );
			})
			
			// Set the array with the countries as the array without EU27_2020
			setCountriesData( res.resultset.filter(country => country.countryCode != 'EU27_2020') );
		});
	}

    const handleCallbackCountry = (countryCallback) => {
		const countryCode = filters.countries.find((country) => country.code == countryCallback.code)
        if (countryCallback.code != countryCode?.code) {
			setFilters( { ...filters, countries: [...filters.countries, countryCallback ] } );
		} else {
			const index = filters.countries.findIndex((country) => country.code == countryCallback.code);
			let newCountryFilters = filters.countries;
			newCountryFilters.splice(index, 1);
			setFilters( {...filters, countries: newCountryFilters } );
		}
	}

    const handleDatasetChange = (dataset) => 
    {
		setFilters( {...filters, dataset: dataset } );
    }

    //when country is selected
    const onSelectCountryTag = (countryCode) => {
        return () => {
            const countryIndex = filters.countries.findIndex((country) => country.code == countryCode);
            let newArray = filters.countries;
            newArray.splice(countryIndex, 1);
			setFilters( {...filters, countries: newArray } );
        }
    }

    // Handles change of page when clicked on the next or prev
    const onChangePage = (pageOfItems) => {
		setPageOfItems(pageOfItems)
    }

	return(
		<div className="social-dialogue">
			<AdviceSection literals={ props.literals } section={["osh-steering","development-eu-countries"]} methodologyData={{section: 'osh-steering', subsection: 'Social dialogue in EU countries', indicator: 354}} />

			<EUCountryCard literals={ props.literals } euData={ euData } page={ 'socialDialogue' }/>

			<section className="container ">
				
				{/*  FILTERS */}
				<form className="row block--filter--wrapper">
					{/*  COUNTRY FILTER */}
					<IndividualCountrySelect literals={ props.literals } selectCountries={ countryList } 
						onClickCountry={ handleCallbackCountry } selectedFilters={ filters } />
					{/* DATASET FILTER */}
					<SelectDataset chart= { '20090' } indicator={ ['554', '555', '557', '556'] } esener= { 'true' } handleDatasetChange={ handleDatasetChange } />
				
					<p className="btn--wrapper text-center">
						<Link to='/osh-steering/social-dialogue/development-eu-countries/country-overview' className="btn-default btn-main-color text-center "> { props.literals.L20028 }</Link>
					</p>					
				</form>
				
				<div className="container">
					<div className="selected--tags-wrapper">
						{ filters && (
							<div>
								{ filters.countries.map((country) => (
									<span key={country.code} className="selected-tag" onClick={ onSelectCountryTag(country.code)}>{country.code == 'EU28' ? '' : `(${country.code})`} {country.name}</span>
								))}
							</div>
						)}
					</div>
					<div className="card--grid xxs-w1 xs-w2 w3 center-text">
						{
							pageOfItems.map((countryData) => (
								<div className="card--block--chart" key={countryData.countryCode}>
									<CountryCards literals={ props.literals } countryData={ countryData } page={ 'socialDialogue' } dataset={ filters.dataset } />
								</div>
							))
						}
					</div>

					<Pagination items={ countriesData } onChangePage={ onChangePage } pageSize={ pageSize }/>
				</div>
			</section>

			<Methodology literals={ props.literals } section={'Social dialogue in EU countries'} />
		</div>
	)
}
DevelopmentEUCountries.displayName = 'DevelopmentEUCountries';
export default DevelopmentEUCountries;